<template>
  <div class="ticket-container">
<!--
    <el-select
      v-model="typeId"
      placeholder="请选择单据类型"
      @change="handelTypeChange"
      style="width: 200px;margin-bottom: 20px;">
      <el-option
        v-for="item in typeList"
        :disabled="isOptionDisabled(item)"
        :key="item.id"
        :label="item.name"
        :value="item.id">
      </el-option>
    </el-select>
-->

    <div class="mb20">
      <el-button
          type="primary"
          v-if="columns.length && typeList.find(head => head.id === typeId && head.minIndex === head.processIndex) !== undefined"
          @click="handleAdd">新增</el-button>
      <el-button type="primary" @click="fetchData">刷新</el-button>
    </div>

    <!-- 数据表格 -->
    <!-- 将复杂:data表达式提取为计算属性 -->
    <el-table
      :data="filteredTableData"
      border
      style="width: 100%">
      <el-table-column
        v-for="col in columns"
        align="center"
        :key="col.prop"
        :prop="col.prop"
        :label="col.label"
        :width="col.width"/>
      <el-table-column align="center" label="操作" width="280">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)" :disabled="scope.row.lastIndex !== scope.row.processIndex || scope.row.conmited === 'Y'">编辑</el-button>
          <el-button size="mini" @click="commitTicket(scope.row)" :disabled="scope.row.lastIndex !== scope.row.processIndex || scope.row.conmited === 'Y'">提交</el-button>
          <el-button size="mini" @click="reBackTicket(scope.row)" :disabled="scope.row.lastIndex !== scope.row.processIndex || scope.row.conmited === 'Y'">打回</el-button>
          <!-- 删除按钮暂时隐藏 -->
          <el-button
            v-if="false"
            size="mini"
            type="danger"
            @click="handleDelete(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 新增/编辑对话框 -->
    <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        append-to-body
        destroy-on-close
        width="80%">
      <ProcessCreate
          :v-if="dialogVisible"
          :formData.sync="formData"
          :columns="columns"
          :columnLines="columnLines"
          :typeId="typeId"
          :processId="processId"
          :processIndex="getCurrentProcessIndex"
          :isFirstProcess="isFirstProcess"
          @submitForm="submitForm"
          @dialogCloce="dialogVisible = false"
      />
    </el-dialog>
  </div>
</template>

<script>
import requestTicket from '@/utils/requestTicket'
import ProcessCreate from "@/views/ticket/ProcessCreate.vue"
import ProcessLine from "@/views/ticket/ProcessLine.vue"

export default {
  components: {
    ProcessCreate,
    ProcessLine
  },
  name: 'Process',
  data() {
    return {
      user: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {},
      processId:null,
      columns:[],
      columnLines:[],
      tableData: [],
      dialogVisible: false,
      dialogTitle: '新增',
      formData: {},
      typeList: [],
      typeHead: [],
      typeLineHead: [],
      ticketLine: [],
      typeId: null
    }
  },
  async mounted() {
    //获取router中的params
    await this.getUserMenu()
    await this.fetchData()
    await this.getTypeList()
    await this.getTypeHead()
    await this.handelTypeChange()
  },
  computed: {

    getCurrentProcessIndex() {
      const item = this.typeList.find(item => item.id === this.typeId);
      return item?.processIndex;
    },
    // 新增计算属性：过滤后的表格数据
    filteredTableData() {
      return this.typeId 
        ? this.tableData.filter(item => item.ticketType == this.typeId) 
        : [];
    },
    // 新增计算属性：判断是否显示新增按钮
    isAddButtonVisible() {
      return this.columns.length && 
        this.typeList.some(head => 
          head.id === this.typeId && 
          head.minIndex === head.processIndex
        );
    },
    // 新增计算属性：判断是否是第一个流程
    isFirstProcess() {
      return this.typeList.some(head => 
        head.id === this.typeId && 
        head.minIndex === head.processIndex
      );
    }
  },
  methods: {
    // 新增方法：判断选项是否禁用
    isOptionDisabled(item) {
      return !this.typeHead.find(head => 
        head.typeId === item.id && 
        head.process && 
        head.process.split(',').includes(this.processId?.toString())
      );
    },
    // 获取数据列表
    async fetchData() {
      try {
        const res = await requestTicket.post('/Ticketing/procedure/execute',
            {procedureName:"get_ticket_his_by_process",parameters:[this.processId.toString()]}
        )
        this.tableData = res.data
      } catch (error) {
        console.error('获取数据失败:', error)
      }
    },
    // 获取数据列表
    async getTicketLine(ticketId) {
      try {
        const res = await requestTicket.post('/Ticketing/procedure/execute',
            {procedureName:"get_ticket_line",parameters:[ticketId]}
        )
        this.ticketLine = res.data
      } catch (error) {
        console.error('获取数据失败:', error)
      }
    },
    async getTypeList() {
      try {
        const res = await requestTicket.post('/Ticketing/procedure/execute',
            {procedureName:"get_ticket_by_process",parameters:[this.processId.toString()]}
        )
        this.typeList = res.data
      } catch (error) {
        console.error('获取数据失败:', error)
      }
    },
    async getTypeHead() {
      try {
        const res = await requestTicket.post('/Ticketing/ticket-head/findAll')
        this.typeHead = res.data
      } catch (error) {
        console.error('获取数据失败:', error)
      }
      try {
        const resLine = await requestTicket.post('/Ticketing/ticket-line-head/findAll')
        this.typeLineHead = resLine.data
      } catch (error) {
        console.error('获取数据失败:', error)
      }
    },
    handelTypeChange() {
      this.formData.ticketType = this.typeId
      this.columns = this.typeHead.filter(item => item.typeId === this.typeId && item.process && item.process.split(',').includes(this.processId.toString()))
      this.columnLines = this.typeLineHead.filter(item => item.typeId === this.typeId && item.process && item.process.split(',').includes(this.processId.toString()))
    },
    // 新增操作
    handleAdd() {
      this.formData = {
        ticketType : this.typeId
      }
      this.ticketLine = [] // 初始化子表数据为空数组
      this.dialogTitle = '新增'
      this.$nextTick(()=>{
        this.submitForm()
      })
    },

    // 编辑操作
    handleEdit(row) {
      this.formData = {
        ...row,
        id:row.tickedId,
        his_id: row.id
      }
      this.getTicketLine(row.tickedId)
      this.dialogTitle = '编辑'
      this.$nextTick(()=>{
        this.dialogVisible = true
      })
    },

    // 提交表单
    async submitForm() {
      try {
        await requestTicket.post('/Ticketing/ticket/save', this.createTicket(this.formData)).then(async res => {
          this.$message.success('操作成功')
          const type = this.typeList.find(item => item.id === this.typeId)
          await requestTicket.post('/Ticketing/ticket-his/save', this.createTicketHis({
            ...res.data,
            id: this.formData.his_id ? this.formData.his_id : null,
            tickedId: res.data.id,
            processId: this.processId,
            processIndex: type.processIndex
          }))
          this.dialogVisible = false
          this.fetchData()
        })
      } catch (error) {
        console.error('操作失败:', error)
        this.$message.error('操作失败')
      }
    },

    createTicketHis(row) {
      return {
        id : row.id ? row.id : null,
        tickedId : row.tickedId ? row.tickedId : null,
        processId : row.processId ? row.processId : null,
        processIndex : row.processIndex ? row.processIndex : null,
        name : row.name ? row.name : null,
        ticketType : row.ticketType ? row.ticketType : null,
        personResponsible : row.personResponsible ? row.personResponsible : null,
        submitter : row.submitter ? row.submitter : null,
        reviewer : row.reviewer ? row.reviewer : null,
        department : row.department ? row.department : null,
        departmentId : row.departmentId ? row.departmentId : null,
        collectionsTime : row.collectionsTime ? row.collectionsTime : null,
        billType : row.billType ? row.billType : null,
        billTypeId : row.billTypeId ? row.billTypeId : null,
        correspondents : row.correspondents ? row.correspondents : null,
        correspondentsId : row.correspondenceId ? row.correspondenceId : null,
        warehouse : row.warehouse ? row.warehouse : null,
        warehouseId : row.warehouseId ? row.warehouseId : null,
        summary : row.summary ? row.summary : null,
        barcodes : row.barcodes ? row.barcodes : null,
        scansNumber : row.scansNumber ? row.scansNumber : null,
        remark : row.remark ? row.remark : null,
        saleType : row.saleType ? row.saleType : null,
        saleTypeId : row.saleTypeId ? row.saleTypeId : null,
        paymentAccount : row.paymentAccount ? row.paymentAccount : null,
        paymentAccountId : row.paymentAccountId ? row.paymentAccountId : null,
        payment : row.payment ? row.payment : null,
        discount : row.discount ? row.discount : null,
        preferential : row.preferential ? row.preferential : null,
        prepaidAmount : row.prepaidAmount ? row.prepaidAmount : null,
        createDate : row.createDate ? row.createDate : null,
        createUser : row.createUser ? row.createUser : null,
        updateDate : row.updateDate ? row.updateDate : null,
        updateUser : row.updateUser ? row.updateUser : null,
        status : row.status ? row.status : null,
        conmited : row.conmited ? row.conmited : null,
      }
    },
    createTicket(row) {
      return {
        id : row.id ? row.id : null,
        name : row.name ? row.name : null,
        ticketType : row.ticketType ? row.ticketType : null,
        personResponsible : row.personResponsible ? row.personResponsible : null,
        submitter : row.submitter ? row.submitter : null,
        reviewer : row.reviewer ? row.reviewer : null,
        department : row.department ? row.department : null,
        departmentId : row.departmentId ? row.departmentId : null,
        collectionsTime : row.collectionsTime ? row.collectionsTime : null,
        billType : row.billType ? row.billType : null,
        billTypeId : row.billTypeId ? row.billTypeId : null,
        correspondents : row.correspondents ? row.correspondents : null,
        correspondentsId : row.correspondenceId ? row.correspondenceId : null,
        warehouse : row.warehouse ? row.warehouse : null,
        warehouseId : row.warehouseId ? row.warehouseId : null,
        summary : row.summary ? row.summary : null,
        barcodes : row.barcodes ? row.barcodes : null,
        scansNumber : row.scansNumber ? row.scansNumber : null,
        remark : row.remark ? row.remark : null,
        saleType : row.saleType ? row.saleType : null,
        saleTypeId : row.saleTypeId ? row.saleTypeId : null,
        paymentAccount : row.paymentAccount ? row.paymentAccount : null,
        paymentAccountId : row.paymentAccountId ? row.paymentAccountId : null,
        payment : row.payment ? row.payment : null,
        discount : row.discount ? row.discount : null,
        preferential : row.preferential ? row.preferential : null,
        prepaidAmount : row.prepaidAmount ? row.prepaidAmount : null,
        createDate : row.createDate ? row.createDate : null,
        createUser : row.createUser ? row.createUser : null,
        updateDate : row.updateDate ? row.updateDate : null,
        updateUser : row.updateUser ? row.updateUser : null,
        status : row.status ? row.status : null
      }
    },

    async commitTicket(row) {
      console.log( row)
      try {
        if (!row.nextProcessIndex) {
          console.log(row)
          await requestTicket.post('/Ticketing/ticket-action/findAll')
              .then(response => {
                const _data = response.data
                _data.filter(item => item.typeId === this.typeId).forEach( action => {
                  this.ticketAction(action,row)
                })
          })
          await requestTicket.post('/Ticketing/ticket/save', this.createTicketHis({
            ...row,
            id: row.tickedId,
            conmited: 'Y'
          }))
        } else {
          await requestTicket.post('/Ticketing/ticket-his/save', this.createTicketHis({
            ...row,
            id: null,
            processId: row.nextProcessId,
            processIndex: row.nextProcessIndex
          }))


          const res = await requestTicket.post('/Ticketing/procedure/execute',
              {procedureName:"get_ticket_line_his_by_process",parameters:[this.processId.toString(),row.tickedId.toString()]}
          )
          for (const item of res.data) {
            await requestTicket.post('/Ticketing/ticket-line-his/save',{
              ...item,
              id: null,
              ticketLineId: item.id,
              processId: row.nextProcessId,
              processIndex: row.nextProcessIndex
            })
          }
        }
        this.fetchData()
      } catch (error) {
        console.error('操作失败:', error)
        this.$message.error('操作失败')
      }
      this.fetchData()
    },
    async ticketAction (action,row) {
      const dto = {
        // childrens : this.ticketLine,
        id : row.id,
        name : row.name,
        ticketType : row.ticketType,
        personResponsible : row.personResponsible,
        submitter : row.submitter,
        reviewer : row.reviewer,
        department : row.department,
        departmentId : row.departmentId,
        collectionsTime : row.collectionsTime,
        billType : row.billType,
        billTypeId : row.billTypeId,
        correspondents : row.correspondents,
        correspondentsId : row.correspondentsId,
        warehouse : row.warehouse,
        warehouseId : row.warehouseId,
        summary : row.summary,
        barcodes : row.barcodes,
        scansNumber : row.scansNumber,
        remark : row.remark,
        saleType : row.saleType,
        saleTypeId : row.saleTypeId,
        paymentAccount : row.paymentAccount,
        paymentAccountId : row.paymentAccountId,
        payment : row.payment,
        discount : row.discount,
        preferential : row.preferential,
        prepaidAmount : row.prepaidAmount,
        createDate : row.createDate,
        createUser : row.createUser,
        updateDate : row.updateDate,
        updateUser : row.updateUser,
        status : row.status
      }
      await this.getTicketLine(row.tickedId)
      dto.childrens = this.ticketLine
      switch (action.actionType){
        case 'inbound':
          await requestTicket.post('/Ticketing/action-util/inbound', dto)
          break;
        case 'inbound-bom':
          await requestTicket.post('/Ticketing/action-util/inbound-bom', dto)
          break;
        case 'outbound':
          await requestTicket.post('/Ticketing/action-util/outbound', dto)
          break;
        case 'outbound-bom':
          await requestTicket.post('/Ticketing/action-util/outbound-bom', dto)
          break;
        case 'createTicket':
          const _dto = {
            ...dto,
            ticketTypeId : action.createTicketTypeId,
            type : action.actionType,
            byChildren : action.createByChildren,
          }
          console.log(_dto)
          await requestTicket.post('/Ticketing/action-util/createTicket', _dto)
          break;
      }
    },
    async reBackTicket(row) {
      try {
        await requestTicket.delete(`/Ticketing/ticket-his/${row.id}`)
        this.$message.success('删除成功')
        this.fetchData()
      } catch (error) {
        console.error('删除失败:', error)
        this.$message.error('删除失败')
      }

    },
    // 删除操作（暂时隐藏）
    async handleDelete(id) {
      try {
        await requestTicket.delete(`/Ticketing/ticket/${id}`)
        this.$message.success('删除成功')
        this.fetchData()
      } catch (error) {
        console.error('删除失败:', error)
        this.$message.error('删除失败')
      }
    },
    // 获取用户菜单
    async getUserMenu() {
      if (!this.user.menus) return
      // 获取当前菜单
      let thisMenu = await this.getMenuChildren(this.user.menus,this.$route.path)
      // 判断是否包含cardIds
      await this.getQueryParameters(thisMenu)
    },
    async getMenuChildren(menus,path){
      if (!menus || menus.length === 0) return
      for (const menu of menus) {
        if (menu.children && menu.children.length > 0) {
          let _menu = await this.getMenuChildren(menu.children,path)
          if (_menu) {
            return _menu
          }
        } else {
          if (menu.path === path) {
            return menu
          }
        }
      }
      return null
    },
    // 获取路由参数
    async getQueryParameters(thisMenu) {
      if (thisMenu) {
        if (thisMenu.description && thisMenu.description.indexOf(":") !== -1) {
          let params = thisMenu.description.split(",")
          let itemParams = {}
          params.forEach(param => {
            let key = param.split(":")[0]
            let value = param.split(":")[1]
            itemParams[key] = value
          })
          // 获取cardIds
          if (itemParams.processId) {
            this.processId = Number(itemParams.processId)
          }
          // 获取cardIds
          if (itemParams.typeId) {
            this.typeId = Number(itemParams.typeId)
            this.handelTypeChange()
          }
          return
        }
      } else {
        //当前路由不存在，跳转404
        this.$router.push({path: "/404"})
      }
    },
    addLine() {
      const newLine = {};
      this.columnLines.forEach(col => {
        newLine[col.prop] = ''; // 根据表头配置初始化子表行字段
      });
      this.ticketLine.push(newLine);
    },
    removeLine(index) {
      this.ticketLine.splice(index, 1);
    }
  }
}
</script>

<style scoped>
.ticket-container {
  padding: 20px;
}
.mb20 {
  margin-bottom: 20px;
}
</style>